<template>
  <div>
    <!-- 抽屉组件 -->
    <el-drawer
      class="drawer"
      title="选择品类"
      :modal="false"
      :append-to-body="true"
      :visible.sync="drawerFlag"
      :before-close="handleClose">
      <div class="container">
        <el-row class="screen" :span="24" style="margin-bottom:20px">
          <el-col :span="6" >
            <el-select v-model="drawerSelectVal" placeholder="请选择品类" class="sel" style="width: 100%" filterable clearable>
              <el-option
                v-for="item in options"
                :key="item.categoryId"
                :label="item.categoryName"
                :value="item.categoryId">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12" :offset="1">
            <el-input placeholder="请输入子品类名" v-model.trim="drawerInput" @keyup.13.native="drawerHandlerKeyUp" class="inp" style="width: 100%">
              <el-button slot="append" icon="el-icon-search" @click="drawerDemand"></el-button>
            </el-input>
          </el-col>
        </el-row>
         <el-table
          ref="multipleTable"
          :data="categoryMangeList"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          >
          <el-table-column
            prop="categoryName"
            label="品类名称"
            >
            <template slot-scope="scope">
              {{ scope.row.categoryName }}
              <el-tooltip class="item" effect="light" content="详情" placement="top-start">
                <i class="el-icon-info click" @click="toCategory(scope.row)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="version"
            label="操作"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="choose(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end"
            v-show="!cateListLoading"
            class="pagination-container">
            <!-- 页码按钮的数量currenCurrent  sizeChange -->
            <el-pagination
              :current-page.sync="cateListQuery.page"
              :page-size="cateListQuery.limit"
              :page-sizes="[10, 20, 30, 50]"
              :total="cateTotal"
              layout="sizes, total, prev, pager, next, jumper"
              @size-change="drawerHandleSizeChange"
              @current-change="drawerHandleCurrentChange"/>
        </el-row>
      </div>
      <div class="drawer-footer">
        <div class="drawer-btn">
          <el-button
          type="primary"
          @click="close"
          >
            关闭
          </el-button>
        </div>
      </div>
    </el-drawer>
    <CategoryDialog :categoryId="categoryId" :listDialog="listDialog" @close="listDialog = false"/>
  </div>
</template>
<script>
// import { getCategoryMange } from '@/api/productRegistration'
import CategoryDialog from './categoryDetail'
import { subCategory, selectSubCategory } from '@/api/categoryManager'
export default {
  props: {
    drawerFlag: {
      type: Boolean
    }
  },
  components: {
    CategoryDialog
  },
  data () {
    return {
      drawerInput: '', // 抽屉组件inputVal
      drawerSelectVal: '',
      options: [],
      // categoryTableData: [], // 抽屉组件table
      categoryMangeList: [],
      // 品类列表分页功能
      cateTotal: 0, // 到时候从后台获取
      cateListLoading: false, // 根据loading来进行显示/隐藏
      cateListQuery: {
        page: 1,
        limit: 10
      },
      cateParams: {},
      listDialog: false,
      categoryId: ''
    }
  },
  watch: {
    drawerInput: {
      handler (val) {
        if (val === '') {
          this.drawerDemand()
        }
      }
      // immediate: true // 是否首次触发
    },
    drawerSelectVal: {
      handler (val) {
        this.cateListQuery.page = 1
        this.getCategoryMangeList()
      }
    }
  },
  async created () {
    await this.getSelList()
    this.getCategoryMangeList()
  },
  methods: {
    toCategory (row) {
      this.listDialog = true
      this.categoryId = row.categoryId
      console.log(row)
    },
    getSelList () {
      selectSubCategory({}).then((res) => {
        this.options = res.data.data
      })
    },
    getCategoryMangeList () {
      this.cateParams.categoryId = this.drawerSelectVal
      this.cateParams.categoryName = this.drawerInput
      this.cateParams.pageNumber = this.cateListQuery.page
      this.cateParams.pageSize = this.cateListQuery.limit
      const params = {
        params: this.cateParams
      }
      subCategory(params)
        .then(res => {
          // if (res.data.data.total < 15) this.cateListLoading = true
          this.cateTotal = res.data.data.total
          this.categoryMangeList = res.data.data.list
        })
    },
    // 关闭抽屉
    handleClose (done) {
      this.$emit('closeDrawer')
    },
    close () {
      this.handleClose()
    },
    // 抽屉搜索功能
    drawerHandlerKeyUp (e) {
      if (e.keyCode === 13) {
        this.drawerDemand()
      }
    },
    // 搜索
    drawerDemand () {
      this.cateListQuery.page = 1
      this.getCategoryMangeList()
    },
    choose (row) {
      console.log(row)
      const obj = {
        categoryParentId: row.categoryParentId,
        categoryId: row.categoryId,
        categoryName: row.categoryName
      }
      this.$emit('getData', obj)
    },

    // 改变drawer页码数量
    drawerHandleSizeChange (val, ele) {
      this.cateListQuery.limit = val
      this.getCategoryMangeList()
    },
    // 改变drawer页码
    drawerHandleCurrentChange (val) {
      this.cateListQuery.page = val
      this.getCategoryMangeList()
    }
  }
}
</script>

<style lang='less' scoped>
  .drawer{
    // z-index: 10000 !important;
    /deep/ .el-drawer__header{
      line-height: 60px !important;
      font-size: 18px !important;
      height: 60px !important;
      border-bottom: 1px solid #efefef !important;
      padding: 0 24px !important;
      margin-bottom: 0 !important;
    }
    /deep/ .el-drawer__body{
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: space-between;
      .container{
        padding: 16px 24px 0 24px !important;
        margin-bottom: 64px;
        border-top: 1px solid #ececec;
        .screen{
          display: flex;
          /deep/ .el-input{
            margin-left: 0;
            width: 90%;
          }
        }
        /deep/ .el-table::before{
          background: white;
        }
        /deep/ .el-table th>.cell:first-child{
          padding: 0 14px
        }
      }
      .click{
        cursor: pointer;
        // color: #efefef
        opacity: .6;
      }
      .drawer-footer{
        position: fixed;
        background: white;
        width: 30%;
        bottom: 0;
        display: flex;
        box-sizing: border-box;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #ececec;
        padding: 10px 24px ;
        height:64px;
        i{
          color: #409eff;
          font-style: normal;
        }
      }
    }
    /deep/ :focus {
      outline: 0;
    }
    .pagination-container{
      margin-top: 10px;
    }
  }
</style>
